<script lang="ts">
    import {dyData, modal} from 'general/store';
    import {TEMPLATE} from 'general/constants';
    import CartImages from '../../components/cartImages/CartImages.svelte';
    import ActionButton from 'general/components/actionButton/ActionButton.svelte';
    import Description from 'general/components/description/Description.svelte';
    import OpacityItem from 'general/components/flip/opacityItem/OpacityItem.svelte';

    import s from './style.module.css';
    import DyButton from 'general/components/dyButton/DyButton.svelte';
    import Policy from 'general/components/policy/Policy.svelte';
</script>

<OpacityItem delayIn={0}>
    <div class={s.main}>
        <Description template={TEMPLATE.SQUARE_EXIT_CART} value={$dyData.description.typ} />
        <div class={s.button}>
            <DyButton
                type="button"
                children="Got It"
                onClick={modal.close}
                size="small"
                color="blue"
                rounded={true}
                width="144px"
                {...$dyData.mainButton?.typ || {}}
            />
        </div>
        <ActionButton
            handleClick={modal.close}
            marginTop="14px"
            fontSize="14px"
            children="Continue Shopping"
            color="blue"
            template={TEMPLATE.SQUARE_EXIT_CART}
        />
        <div class={s.wrapper}>
            <CartImages />
            <Policy padding="163px 77px 0px" />
        </div>
    </div>
</OpacityItem>
